import { render, staticRenderFns } from "./payment-component-crud.vue?vue&type=template&id=3c69752b&"
import script from "./payment-component-crud.js?vue&type=script&lang=js&"
export * from "./payment-component-crud.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports